/* eslint-disable react/no-unused-prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import appSettings from '../../../../config/appSettings';

const applicantsArr = Array.from(Array(6).keys());
const styles = ({ spacing: { unit } }) => ({
    root: {
        padding: unit * 2,
    },
    button: {
        marginRight: unit * 2,
        fontSize: '0.875rem',
    },
});

function Applicants(props) {
    return (props.applicationType === 'personal' && !appSettings.onlyOneApplicant)
        ? (
            <div className={props.classes.root}>
                <Typography variant="subheading" gutterBottom>
                    Number of applicants:
                </Typography>
                {applicantsArr.map(item => (
                    <Button
                        key={item + 1}
                        variant="fab"
                        mini
                        color={props.applicants === (item + 1) ? 'primary' : 'default'}
                        className={props.classes.button}
                        onClick={() => props.setApplicants(item + 1)}
                    >
                        {item + 1}
                    </Button>
                ))}
            </div>
        )
        : '';
}

Applicants.propTypes = {
    classes: PropTypes.object.isRequired,
    applicationType: PropTypes.string.isRequired,
    applicants: PropTypes.number.isRequired,
    setApplicants: PropTypes.func.isRequired,
};

export default withStyles(styles)(Applicants);



// WEBPACK FOOTER //
// ./src/app/FormStepper/QuickQuote/components/Applicants.js